<template>
    <div v-loading="dataLoading">
        <el-form
            :model="formData"
            ref="formData"
            label-position="top"
        >
            <div class="group">
                <div class="page-group-title"><span>用户信息</span></div>
                <UserInfo :formData.sync="formData" :id="id"></UserInfo>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>收款信息</span></div>
                <ReceiptInfo :formData.sync="formData"></ReceiptInfo>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>证件信息</span></div>
                <AccountInfo :formData.sync="formData" :type="2"></AccountInfo>
            </div>
            <div v-if="id" class="group MT20">
                <div class="page-group-title"><span>状态信息</span></div>
                <StatusInfo :formData.sync="formData"></StatusInfo>
            </div>
            <div class="group MT20">
                <el-button @click="goBack">返回</el-button>
                <el-button
                    v-if="$utils.have('/goods/receivables/createOrUpdateReceivablesInfo')"
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >提交</el-button
                >
            </div>
        </el-form>
    </div>
</template>

<script>
import UserInfo from './components/userInfo';
import ReceiptInfo from '@/views/finance/components/receiptInfo';
import AccountInfo from '@/views/finance//components/accountInfo';
import StatusInfo from './components/statusInfo';
export default {
    props:{
        id:{
            type: [String,Number],
            default: ''
        }
    },
    components:{UserInfo,ReceiptInfo,AccountInfo,StatusInfo},
    data(){
        return{
            redirect: this.$route.query.redirect || '',
            dataLoading: false,
            formData:{
                bankCityCode: '',
                bankProvinceCode: '',
                userId:'',
                name:'',
                userType:'',
                contractSn:'',
                contractExpireTime:'',
                userName:'',
                userTelephone:'',
                userEmail:'',
                address:'',
                bankId:1,
                bankAddress:'',
                bankCardId:'',
                bankAccount:'',
                accountType:1,
                licenseNumber:'',
                accountPic:'',
                otherPic:'',
                accountIdName:'',
                pic1:'',
                pic2:'',
            },
            btnLoading:false,
        }
    },
    mounted(){
        if(this.id){
            this.getDataDetail();
        }
    },
    methods:{
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/goods/receivables/getInfoDetail",
                params: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        const _accountPic = result.accountPic ? result.accountPic.split(',') : [];
                        this.formData = {
                            ...this.formData,
                            ...result,
                            pic1: _accountPic[0] || '',
                            pic2: _accountPic[1] || '', 
                        }
                    } else {
                        this.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //设置图片
        setAccountPic(){
            const _pic = [];
            if(this.formData.pic1) _pic.push(this.formData.pic1);
            if(this.formData.pic2) _pic.push(this.formData.pic2);

            this.formData.accountPic = _pic.toString(); 
        },
        //表单提交
        onSubmit(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.setAccountPic();
                    this.$request({
                        url: "/goods/receivables/createOrUpdateReceivablesInfo",
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-card{
    .el-col{
        line-height: 28px;
    }
}
</style>